<div class="container request-tracking-history">
  <div [appLoadingAnimation]="!isLoaded" class="app-loading">
    @if (quoteDetails) {
      <div class="row">
        <div class="col-12">
          <h3 [attr.data-test]="'title-requestDetails'">
            {{ getTranslationGroup() + '.page-title' | translate }}
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-9">
          <h6 class="request-status" [attr.data-test]="'title-requestStatus'">
            {{ getTranslationGroup() + '.status-of' | translate }} {{ quoteDetails.id }}
          </h6>
          <div class="request-status__desc">
            <span [ngClass]="statusIcon()"></span>
            <span [attr.data-test]="'desc-requestStatus'">
              @if (isRequestQuoteClosedLoopEnabled && quoteDetails.attributes.shownVersion.status) {
                <span [innerHTML]="getVersionStatusTranslationKey(quoteDetails.attributes.shownVersion.status) | translate:
                  {fileName: quoteDetails.attributes.shownVersion.lastQuoteFileName ?? ''}">
                </span>
              } @else {
                <span>{{ getTranslationGroup() + '.status-bar-request-' + quoteDetails.attributes.status + '-title' | translate: {number: quoteDetails.id} }}</span>
              }
            </span>
          </div>
        </div>
        <div class="col-12 col-lg-3 display-flex flex-column">
          <div class="back-to-cart__wrapper">
            <button type="button" class="back-to-cart" (click)="backToOrders()"
              [attr.data-test]="'button-backToRequests'">
              <span class="icon-arrow-left"></span>
              @if (isHarmonizedPurchaseActivityEnabled$ | async) {
                <span [attr.data-test]="'desc-backToPurchaseActivity'">
                  {{ 'order-details.back-to-purchase-activity' | translate }}
                </span>
              } @else {
                <span [attr.data-test]="'desc-backToRequests'">
                  {{ getTranslationGroup() + '.back-btn' | translate }}
                </span>
              }
            </button>
          </div>
          @if (!isGeneratedQuoteWorkflow()) {
            <div class="cancel-button__wrapper">
              <button
                type="button"
                class="cancel-button"
                [disabled]="cancelButtonDisabled()"
                (click)="cancelQuoteRequestModal()"
                [attr.data-test]="'button-cancelRequest'">
                {{ 'request-tracking.cancel-btn' | translate }}
              </button>
            </div>
          }
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <app-steps-bar
            [currentStatus]="quoteDetails.attributes.status"
            [currentVersionStatus]="quoteDetails.attributes.shownVersion.status?.toLowerCase()"
            [currentDesc]="quoteDetails.attributes.quoteNumber"
            [scenarioType]="isGeneratedQuoteWorkflow() ? generatedQuoteType : quoteRequestType"
            [comment]="quoteDetails.attributes.statusComment"
            [isRequestQuoteClosedLoopEnabled]="isRequestQuoteClosedLoopEnabled">
          </app-steps-bar>
        </div>
      </div>
      <div class="row">
        <div class="col-12 request-items-styling">
          <h4 [attr.data-test]="'title-requestItems'">
            {{ getTranslationGroup() + '.your-items' | translate }}
          </h4>
        </div>
      </div>
      <div class="row justify-content-between table-header-colors">
        <div class="col-12 col-lg-3">
          <div class="col-12 col-lg-10">{{ getTranslationGroup() + '.col-id' | translate }}</div>
          <div class="col-12 col-lg-10">
            <strong [attr.data-test]="'desc-requestId'">
              {{ quoteDetails.id }}
            </strong>
          </div>
        </div>
        <div class="col-12 col-lg-2">
          <div class="col-12 col-lg-10" [attr.data-test]="'label-requestDate'">
            {{ getTranslationGroup() + '.col-date' | translate }}
          </div>
          <div class="col-12 col-lg-10">
            <strong [attr.data-test]="'desc-requestDate'">
              {{ quoteDetails.attributes.createdAt | formatDate }}
            </strong>
          </div>
        </div>
        <div class="col-12 col-lg-2 total-qty">
          <div class="col-12" [attr.data-test]="'label-requestTotalQuantity'">
            {{ 'order-tracking-history.total-quantity' | translate }}
          </div>
          <div class="col-12">
            <strong [attr.data-test]="'desc-requestTotalQuantity'">
              {{ totalQuantity }} {{ (totalQuantity === 1 ? 'order-tracking-history.item' : 'order-tracking-history.items') | translate }}
            </strong>
          </div>
        </div>
        @if (isGeneratedQuoteWorkflow()) {
          <div class="col-12 col-lg-4 total-price">
            <div class="col-12 col-lg-10" [attr.data-test]="'label-requestTotalSum'">
              {{ 'order-tracking-history.total-sum' | translate }}
            </div>
            <div class="col-12 col-lg-10">
              <strong [attr.data-test]="'desc-requestTotalSum'">
                {{ quoteDetails.attributes.shownVersion.cart.totals.grandTotal | currency: quoteDetails.attributes.shownVersion.cart.currency }}
              </strong>
              <p>
                @if (AppUtils.isStoreActive(EStoreTypes.IN); ) {
                  <span [attr.data-test]="'desc-excludesVat'">
                    {{ 'checkout-delivery-details.price-info' | translate }}
                  </span>
                } @else {
                  <span [attr.data-test]="'desc-excludesVat'">
                    {{ 'shop-cart.excludes-vat' | translate }}
                  </span>
                }
                <br/>
                <span [attr.data-test]="'desc-pricingValidation'">
                  {{ 'shop-cart.pricing-validation' | translate }}
                </span>
              </p>
            </div>
          </div>
        }
        <div [ngClass]="isGeneratedQuoteWorkflow() ? 'col-12 col-lg-12' : 'col-12 col-lg-4'">
          <div class="col-12 col-lg-12">
            <span [attr.data-test]="'label-selectedSystem'">
              {{ 'request-tracking.selected-system' | translate }}
            </span>
            <span [attr.data-test]="'desc-selectedSystem'">
              {{ quoteDetails.attributes.systemDetails ? (quoteDetails.attributes.systemDetails | selectedSystem) : '-' }}
            </span>
          </div>
          <div class="col-12 col-lg-12">
            <span [attr.data-test]="'label-company'">
              {{ 'request-tracking.company' | translate }}
            </span>
            <span [attr.data-test]="'desc-company'">
              {{ quoteDetails.attributes.systemDetails ? (quoteDetails.attributes.systemDetails | companyDetails) : '-' }}
            </span>
          </div>
          <div class="col-12 col-lg-10">
            <span [attr.data-test]="'label-customerName'">
              {{ 'request-tracking.contact' | translate }}
            </span>
            <span [attr.data-test]="'desc-customerName'">
              {{ quoteDetails.attributes.pointOfContact.firstName }} {{ quoteDetails.attributes.pointOfContact.lastName }}
            </span>
          </div>
          <div class="col-12 col-lg-10">
            <span [attr.data-test]="'label-customerPhone'">
              {{ 'request-tracking.contact-tel' | translate }}
            </span>
            <span [attr.data-test]="'desc-customerPhone'">
              {{ quoteDetails.attributes.pointOfContact.phone }}
            </span>
          </div>
          <div class="col-12 col-lg-10">
            <span [attr.data-test]="'label-customerEmail'">
              {{ 'request-tracking.contact-email' | translate }}
            </span>
            <span [attr.data-test]="'desc-customerEmail'">
              {{ quoteDetails.attributes.pointOfContact.email }}
            </span>
          </div>
        </div>
      </div>
      <br>
        <div class="row">
          <div class="col-12 col-lg-8 items-border-styling">
            @for (item of quoteDetails.attributes.shownVersion.cart.items; track item) {
              <div class="item-border-styling">
                <div class="row item-row-styling" [attr.data-test]="'request-item-' + item.name">
                  <div class="col-2">
                    <img [src]="ImageUtils.addPreset(item.metadata.image, ImagePreset.Thumbnail)" [alt]="item.name">
                  </div>
                  <div class="col-8">
                    <h6 class="item-name-styling" [attr.data-test]="'title-name'">
                      <a [routerLink]="['/product/', item.abstractSku]"> {{ item.name }}</a>
                    </h6>
                    @if (isGeneratedQuoteWorkflow()) {
                      <div>
                        <h5 class="item-price" [attr.data-test]="'title-price'">
                          {{ item.calculations.unitPrice | currency: quoteDetails.attributes.shownVersion.cart.currency }}
                        </h5>
                      </div>
                    }
                    @if (item.systemDetails) {
                      <div>
                        <div class="padding-styling">
                          <span [attr.data-test]="'label-selectedSystem'">
                            {{ 'request-tracking.selected-system' | translate }}
                          </span>
                          <div class="item-system-details-styling">
                            @if (item.systemDetails) {
                              <span [attr.data-test]="'desc-selectedSystem'">
                                {{ item.systemDetails | selectedSystem }}
                              </span>
                            }
                          </div>
                        </div>
                        <div class="padding-styling">
                          <span [attr.data-test]="'label-company'">
                            {{ 'request-tracking.company' | translate }}
                          </span>
                          <div class="item-system-details-styling">
                            @if (item.systemDetails) {
                              <span [attr.data-test]="'desc-company'">
                                {{ item.systemDetails | companyDetails }}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-2">
                    <div [attr.data-test]="'desc-quantity'">
                      {{ item.quantity }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="col-12 col-lg-4 address-styling">
            <strong [attr.data-test]="'label-deliveryAddress'">
              {{ 'order-tracking-history.delivery-address' | translate }}
            </strong>
            <div [attr.data-test]="'desc-deliveryAddress'">
              <div [attr.data-test]="'desc-deliveryAddressName'">
                @if (quoteDetails.attributes.shippingAddress.firstName !== 'empty') {
                  <span
                    [attr.data-test]="'desc-deliveryAddressFirstName'">
                    {{ quoteDetails.attributes.shippingAddress.firstName }}
                  </span>
                }
                @if (quoteDetails.attributes.shippingAddress.lastName !== 'empty') {
                  <span
                    [attr.data-test]="'desc-deliveryAddressLastName'">
                    {{ quoteDetails.attributes.shippingAddress.lastName }}
                  </span>
                }
              </div>
              <div [attr.data-test]="'desc-deliveryAddressAddress1'">
                {{ quoteDetails.attributes.shippingAddress.address1 }}
              </div>
              @if (quoteDetails.attributes.shippingAddress.address3 !== 'empty') {
                <div
                  [attr.data-test]="'desc-deliveryAddressAddress3'">
                  {{ quoteDetails.attributes.shippingAddress.address3 }}
                </div>
              }
              <div class="address-styling--inline">
                @if (quoteDetails.attributes.shippingAddress.zipCode !== 'empty') {
                  <div
                    [attr.data-test]="'desc-deliveryAddressZipCode'">
                    {{ quoteDetails.attributes.shippingAddress.zipCode }}&nbsp;
                  </div>
                }
                @if (quoteDetails.attributes.shippingAddress.city !== 'empty') {
                  <div
                    [attr.data-test]="'desc-deliveryAddressCity'">
                    {{ quoteDetails.attributes.shippingAddress.city }}
                  </div>
                }
                @if (quoteDetails.attributes.shippingAddress.address2 !== 'empty') {
                  <div
                    [attr.data-test]="'desc-deliveryAddressAddress2'">
                    , {{ quoteDetails.attributes.shippingAddress.address2 }}
                  </div>
                }
              </div>
              @if (quoteDetails.attributes.shippingAddress.country !== 'empty') {
                <div
                  [attr.data-test]="'desc-deliveryAddressCountry'">
                  {{ quoteDetails.attributes.shippingAddress.country?.name || quoteDetails.attributes.shippingAddress.country }}
                </div>
              }
            </div>
            @if (quoteDetails.attributes.taxNumber) {
              <div class="cart-tax-number">
                <ng-container>
                  <strong [attr.data-test]="'label-taxNumber'">
                    {{ 'order-approve.billing-tax-number' | translate }}
                  </strong>
                  <div [attr.data-test]="'desc-taxNumber'">
                    {{ quoteDetails.attributes.taxNumber }}
                  </div>
                </ng-container>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <app-modal
    [id]="'cancel-request-modal'"
    [open]="showModalCancelOrder"
    [title]="'request-tracking.cancel-request-modal-title' | translate"
    (crossClick)="restartShowModal()"
    (outsideClick)="restartShowModal()">
    <ng-container ngProjectAs="[slot][body]">
      <h5 class="cancel-request-modal-body">
        {{ 'request-tracking.cancel-request-modal-body' | translate:{number: orderId} }}
      </h5>
    </ng-container>
    <ng-container ngProjectAs="[slot][footer]">
      <button type="button" (click)="restartShowModal()" class="button button" data-dismiss="modal-dialog">
        {{ 'request-tracking.cancel-request-modal-abandon-btn' | translate }}
      </button>
      <button
        type="button"
        class="button button--primary"
        data-dismiss="modal-dialog"
        (click)="cancelQuoteRequest(orderId)">
        {{ 'request-tracking.cancel-request-modal-ok-btn' | translate }}
      </button>
    </ng-container>
  </app-modal>
